// Mapeamento de concelhos de Portugal Continental + Ilhas para distritos
export const COUNTY_TO_DISTRICT = {
  // Aveiro
  "Águeda": "Aveiro", "Albergaria-a-Velha": "Aveiro", "Anadia": "Aveiro", "Arouca": "Aveiro",
  "Aveiro": "Aveiro", "Castelo de Paiva": "Aveiro", "Espinho": "Aveiro", "Estarreja": "Aveiro",
  "Ílhavo": "Aveiro", "Mealhada": "Aveiro", "Murtosa": "Aveiro", "Oliveira de Azeméis": "Aveiro",
  "Oliveira do Bairro": "Aveiro", "Ovar": "Aveiro", "Santa Maria da Feira": "Aveiro",
  "São João da Madeira": "Aveiro", "Sever do Vouga": "Aveiro", "Vagos": "Aveiro",
  "Vale de Cambra": "Aveiro",
  // Beja
  "Aljustrel": "Beja", "Almodôvar": "Beja", "Alvito": "Beja", "Barrancos": "Beja",
  "Beja": "Beja", "Castro Verde": "Beja", "Cuba": "Beja", "Ferreira do Alentejo": "Beja",
  "Mértola": "Beja", "Moura": "Beja", "Odemira": "Beja", "Ourique": "Beja",
  "Serpa": "Beja", "Vidigueira": "Beja",
  // Braga
  "Amares": "Braga", "Barcelos": "Braga", "Braga": "Braga", "Cabeceiras de Basto": "Braga",
  "Celorico de Basto": "Braga", "Esposende": "Braga", "Fafe": "Braga", "Guimarães": "Braga",
  "Póvoa de Lanhoso": "Braga", "Terras de Bouro": "Braga", "Vieira do Minho": "Braga",
  "Vila Nova de Famalicão": "Braga", "Vila Verde": "Braga", "Vizela": "Braga",
  // Bragança
  "Alfândega da Fé": "Bragança", "Bragança": "Bragança", "Carrazeda de Ansiães": "Bragança",
  "Freixo de Espada à Cinta": "Bragança", "Macedo de Cavaleiros": "Bragança",
  "Miranda do Douro": "Bragança", "Mirandela": "Bragança", "Mogadouro": "Bragança",
  "Torre de Moncorvo": "Bragança", "Vila Flor": "Bragança", "Vimioso": "Bragança",
  "Vinhais": "Bragança",
  // Castelo Branco
  "Belmonte": "Castelo Branco", "Castelo Branco": "Castelo Branco", "Covilhã": "Castelo Branco",
  "Fundão": "Castelo Branco", "Idanha-a-Nova": "Castelo Branco", "Oleiros": "Castelo Branco",
  "Penamacor": "Castelo Branco", "Proença-a-Nova": "Castelo Branco", "Sertã": "Castelo Branco",
  "Vila de Rei": "Castelo Branco", "Vila Velha de Ródão": "Castelo Branco",
  // Coimbra
  "Arganil": "Coimbra", "Cantanhede": "Coimbra", "Coimbra": "Coimbra",
  "Condeixa-a-Nova": "Coimbra", "Figueira da Foz": "Coimbra", "Góis": "Coimbra",
  "Lousã": "Coimbra", "Mira": "Coimbra", "Miranda do Corvo": "Coimbra",
  "Montemor-o-Velho": "Coimbra", "Oliveira do Hospital": "Coimbra", "Pampilhosa da Serra": "Coimbra",
  "Penacova": "Coimbra", "Penela": "Coimbra", "Soure": "Coimbra", "Tábua": "Coimbra",
  "Vila Nova de Poiares": "Coimbra",
  // Évora
  "Alandroal": "Évora", "Arraiolos": "Évora", "Borba": "Évora", "Estremoz": "Évora",
  "Évora": "Évora", "Montemor-o-Novo": "Évora", "Mora": "Évora", "Mourão": "Évora",
  "Portel": "Évora", "Redondo": "Évora", "Reguengos de Monsaraz": "Évora",
  "Viana do Alentejo": "Évora", "Vila Viçosa": "Évora",
  // Faro
  "Albufeira": "Faro", "Alcoutim": "Faro", "Aljezur": "Faro", "Castro Marim": "Faro",
  "Faro": "Faro", "Lagoa": "Faro", "Lagos": "Faro", "Loulé": "Faro",
  "Monchique": "Faro", "Olhão": "Faro", "Portimão": "Faro", "São Brás de Alportel": "Faro",
  "Silves": "Faro", "Tavira": "Faro", "Vila do Bispo": "Faro", "Vila Real de Santo António": "Faro",
  // Guarda
  "Aguiar da Beira": "Guarda", "Almeida": "Guarda", "Celorico da Beira": "Guarda",
  "Figueira de Castelo Rodrigo": "Guarda", "Fornos de Algodres": "Guarda", "Gouveia": "Guarda",
  "Guarda": "Guarda", "Manteigas": "Guarda", "Mêda": "Guarda", "Pinhel": "Guarda",
  "Sabugal": "Guarda", "Seia": "Guarda", "Trancoso": "Guarda", "Vila Nova de Foz Côa": "Guarda",
  // Leiria
  "Alcobaça": "Leiria", "Alvaiázere": "Leiria", "Ansião": "Leiria", "Batalha": "Leiria",
  "Bombarral": "Leiria", "Caldas da Rainha": "Leiria", "Castanheira de Pera": "Leiria",
  "Figueiró dos Vinhos": "Leiria", "Leiria": "Leiria", "Marinha Grande": "Leiria",
  "Nazaré": "Leiria", "Óbidos": "Leiria", "Pedrógão Grande": "Leiria", "Peniche": "Leiria",
  "Pombal": "Leiria", "Porto de Mós": "Leiria",
  // Lisboa
  "Alenquer": "Lisboa", "Amadora": "Lisboa", "Arruda dos Vinhos": "Lisboa",
  "Azambuja": "Lisboa", "Cadaval": "Lisboa", "Cascais": "Lisboa", "Lisboa": "Lisboa",
  "Loures": "Lisboa", "Lourinhã": "Lisboa", "Mafra": "Lisboa", "Odivelas": "Lisboa",
  "Oeiras": "Lisboa", "Sintra": "Lisboa", "Sobral de Monte Agraço": "Lisboa",
  "Torres Vedras": "Lisboa", "Vila Franca de Xira": "Lisboa",
  // Portalegre
  "Alter do Chão": "Portalegre", "Arronches": "Portalegre", "Avis": "Portalegre",
  "Campo Maior": "Portalegre", "Castelo de Vide": "Portalegre", "Crato": "Portalegre",
  "Elvas": "Portalegre", "Fronteira": "Portalegre", "Gavião": "Portalegre",
  "Marvão": "Portalegre", "Monforte": "Portalegre", "Nisa": "Portalegre",
  "Ponte de Sor": "Portalegre", "Portalegre": "Portalegre", "Sousel": "Portalegre",
  // Porto
  "Amarante": "Porto", "Baião": "Porto", "Felgueiras": "Porto", "Gondomar": "Porto",
  "Lousada": "Porto", "Maia": "Porto", "Marco de Canaveses": "Porto", "Matosinhos": "Porto",
  "Paços de Ferreira": "Porto", "Paredes": "Porto", "Penafiel": "Porto", "Porto": "Porto",
  "Póvoa de Varzim": "Porto", "Santo Tirso": "Porto", "Valongo": "Porto", "Vila do Conde": "Porto",
  "Vila Nova de Gaia": "Porto", "Gaia": "Porto", "Trofa": "Porto",
  // Santarém
  "Abrantes": "Santarém", "Alcanena": "Santarém", "Almeirim": "Santarém",
  "Alpiarça": "Santarém", "Benavente": "Santarém", "Cartaxo": "Santarém",
  "Chamusca": "Santarém", "Constância": "Santarém", "Coruche": "Santarém",
  "Entroncamento": "Santarém", "Ferreira do Zêzere": "Santarém", "Golegã": "Santarém",
  "Mação": "Santarém", "Ourém": "Santarém", "Rio Maior": "Santarém",
  "Salvaterra de Magos": "Santarém", "Santarém": "Santarém", "Sardoal": "Santarém",
  "Tomar": "Santarém", "Torres Novas": "Santarém", "Vila Nova da Barquinha": "Santarém",
  // Setúbal
  "Alcácer do Sal": "Setúbal", "Comporta": "Setúbal", "Almada": "Setúbal", "Barreiro": "Setúbal",
  "Grândola": "Setúbal", "Moita": "Setúbal", "Montijo": "Setúbal", "Palmela": "Setúbal",
  "Santiago do Cacém": "Setúbal", "Seixal": "Setúbal", "Sesimbra": "Setúbal",
  "Setúbal": "Setúbal", "Sines": "Setúbal",
  // Viana do Castelo
  "Arcos de Valdevez": "Viana do Castelo", "Caminha": "Viana do Castelo",
  "Melgaço": "Viana do Castelo", "Monção": "Viana do Castelo",
  "Paredes de Coura": "Viana do Castelo", "Ponte da Barca": "Viana do Castelo",
  "Ponte de Lima": "Viana do Castelo", "Valença": "Viana do Castelo",
  "Viana do Castelo": "Viana do Castelo", "Vila Nova de Cerveira": "Viana do Castelo",
  // Vila Real
  "Alijó": "Vila Real", "Boticas": "Vila Real", "Chaves": "Vila Real",
  "Mesão Frio": "Vila Real", "Mondim de Basto": "Vila Real", "Montalegre": "Vila Real",
  "Murça": "Vila Real", "Peso da Régua": "Vila Real", "Ribeira de Pena": "Vila Real",
  "Sabrosa": "Vila Real", "Santa Marta de Penaguião": "Vila Real",
  "Valpaços": "Vila Real", "Vila Pouca de Aguiar": "Vila Real", "Vila Real": "Vila Real",
  "Peso da Régua": "Vila Real",
  // Viseu
  "Armamar": "Viseu", "Carregal do Sal": "Viseu", "Castro Daire": "Viseu",
  "Cinfães": "Viseu", "Lamego": "Viseu", "Mangualde": "Viseu", "Moimenta da Beira": "Viseu",
  "Mortágua": "Viseu", "Nelas": "Viseu", "Oliveira de Frades": "Viseu",
  "Penalva do Castelo": "Viseu", "Penedono": "Viseu", "Resende": "Viseu",
  "Santa Comba Dão": "Viseu", "São João da Pesqueira": "Viseu", "Sátão": "Viseu",
  "Sernancelhe": "Viseu", "Tabuaço": "Viseu", "Tarouca": "Viseu",
  "Tondela": "Viseu", "Vila Nova de Paiva": "Viseu", "Viseu": "Viseu",
  "Cinfães": "Viseu",
  // Freguesias/popular towns mapped to their district for delivery & SEO
  "Ericeira": "Lisboa",
  "Fátima": "Santarém",
  "Caracavelos": "Lisboa",
};

export function getCountyDistrict(countyName) {
  if (!countyName) return "Outros";
  return COUNTY_TO_DISTRICT[countyName] || COUNTY_TO_DISTRICT[countyName.trim()] || "Outros";
}

export function groupCountiesByDistrict(counties) {
  // Freguesias (com parent_concelho) são aninhadas sob o concelho pai no
  // selector — não aparecem como entradas separadas ao nível do distrito.
  const concelhos = counties.filter((c) => !c.parent_concelho);
  const groups = {};
  for (const county of concelhos) {
    const district = getCountyDistrict(county.name);
    if (!groups[district]) groups[district] = [];
    groups[district].push(county);
  }
  // Sort districts by proximity to Lisbon (closest first), "Outros" last
  const DISTRICT_ORDER = [
    "Lisboa", "Setúbal", "Santarém", "Leiria", "Évora", "Portalegre",
    "Coimbra", "Aveiro", "Castelo Branco", "Guarda", "Viseu",
    "Porto", "Braga", "Vila Real", "Bragança", "Viana do Castelo",
    "Beja", "Faro"
  ];
  const sorted = Object.keys(groups).sort((a, b) => {
    if (a === "Outros") return 1;
    if (b === "Outros") return -1;
    const ia = DISTRICT_ORDER.indexOf(a);
    const ib = DISTRICT_ORDER.indexOf(b);
    if (ia === -1 && ib === -1) return a.localeCompare(b, "pt");
    if (ia === -1) return 1;
    if (ib === -1) return -1;
    return ia - ib;
  });
  const result = {};
  for (const key of sorted) {
    result[key] = groups[key].sort((a, b) => a.name.localeCompare(b.name, "pt"));
  }
  return result;
}